// @flow
import { onlyComplex } from 'app/components/common/reports/filters/productionType';


export default onlyComplex;
